import CONF from 'config/conf.singleton';
import H from 'constants/httpMethod.const';
import { fromAnyDateToZuluDayBgn, fromAnyDateToZuluDayEnd } from 'utils/converters/time/from.util';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';

export const beTransactionPayoutRead = actionEndpointBe(
  'beTransactionPayoutRead',
  H.get,
  'checkout/:salonId/transactionlog/payout?start=:bgn&end=:end',
  (options, extra) => ({
    ...options,
    inert: false,
    base: CONF.transactionApiRoot,
    params: {
      bgn: fromAnyDateToZuluDayBgn(extra?.bgn),
      end: fromAnyDateToZuluDayEnd(extra?.end),
    },
  }),
);
